import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import Container from "../layouts/Container";

const ProfileTabContent = props => {
	return <Container>Hellow Driver!!</Container>;
};

ProfileTabContent.propTypes = {
	keyValue: PropTypes.string,
  	dashboardType: PropTypes.string.isRequired
};

ProfileTabContent.defaultProps = {
	// defaultProp: ''
};

export default ProfileTabContent;



// WEBPACK FOOTER //
// ./src/components/dashboard/ProfileTabContent.js